export default __webpack_public_path__ + "static/media/iconExcelBlack.8d6d862a.svg";